import { useSelector } from 'react-redux';
import { getLastTransactionCreated } from '../selectors/transactions';

const useLastTransactionCreated = () => {
	return useSelector(getLastTransactionCreated)
}

export default useLastTransactionCreated;